const CHUNK_RELOAD_GUARD_KEY = 'xo_chunk_reload_attempted'

const CHUNK_ERROR_PATTERNS = [
  'failed to fetch dynamically imported module',
  'importing a module script failed',
  'dynamically imported module',
  'loading chunk',
  'chunkloaderror',
]

export const isChunkLoadingError = (error: unknown): boolean => {
  const message = String((error as { message?: string })?.message || '').toLowerCase()
  return CHUNK_ERROR_PATTERNS.some((pattern) => message.includes(pattern))
}

export const recoverFromChunkError = (): boolean => {
  const hasReloaded = sessionStorage.getItem(CHUNK_RELOAD_GUARD_KEY) === '1'

  if (hasReloaded) {
    return false
  }

  sessionStorage.setItem(CHUNK_RELOAD_GUARD_KEY, '1')
  window.location.reload()
  return true
}

export const resetChunkReloadGuard = (): void => {
  sessionStorage.removeItem(CHUNK_RELOAD_GUARD_KEY)
}
